export default {
    LOAD_PAGES(state, pages) {
        state.items = pages;
    }
}